import WebFont from 'webfontloader';

export default (): void => {
    WebFont.load({
        google: {
            families: ['DM Sans:400,700&display=swap']
        },
        timeout: 4000
    })
};
